export default __webpack_public_path__ + "static/media/moto-1.34de883c.jpg";